export enum Mode {
    View,
    Edit,
    Clone,
    New
}